import { render, staticRenderFns } from "./payInfo.vue?vue&type=template&id=8dd2a994&scoped=true&lang=pug&"
import script from "./payInfo.vue?vue&type=script&lang=js&"
export * from "./payInfo.vue?vue&type=script&lang=js&"
import style0 from "./payInfo.vue?vue&type=style&index=0&id=8dd2a994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd2a994",
  null
  
)

export default component.exports